import { render, staticRenderFns } from "./_Motion.vue?vue&type=template&id=f268135c&"
import script from "./_Motion.vue?vue&type=script&lang=js&"
export * from "./_Motion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports